<template>
    <div>
        <v-toolbar flat color="white">
            <v-text-field
                    v-model="search"
                    append-icon="search"
                    :label="$t('monitoring.ridesSearch.rideId')"
                    single-line
                    hide-details
                    @keyup.enter="getData"
            ></v-text-field>
        </v-toolbar>
        <transition name="fade">
            <ride-page v-if="id" :ride_id="id"></ride-page>
        </transition>
    </div>
</template>

<script>
    import loading from "@/components/LoadingComponent";
    import RidePage from "@/views/RidePage";

    export default {
        name: "RideSearch",
        title() {
            return this.$t("monitoring.ridesSearch.title");
        },
        components: {RidePage, loading},
        props: ['provider'],
        data() {
            return {
                search: null,
                id: null,
                dialog: true,
                valid: false
            }
        },
        methods: {
            getData() {
                this.id = this.search;
            },

        }
    }
</script>

<style scoped>

</style>